import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import './filters/filters.js'
import App from './App.vue'
import NotAuthorizedApp from './NotAuthorized.vue'
import NoKeykloakResponseApp from './NoKeycloakResponse.vue'
import router from './router'
import axios from 'axios'
import {setBearerToken} from '@/http'
import store from './store'
import LogRocket from 'logrocket'
import VueAnalytics from 'vue-analytics'
import "./common/directives.js"
import "./common/filters.js"

import i18n from './locales'
import { Plugin } from 'vue-fragment'
Vue.use(Plugin)

Vue.config.productionTip = false
Vue.config.devtools = true

var keycloak = null
try {
  //linter desabilitado nesta linha para não reclamar do keycloack
  //o import dele é feito no index.html
  // eslint-disable-next-line
  keycloak = Keycloak({
    realm: 'Granter',
    url: process.env.VUE_APP_URL_KEYCLOAK,
    'ssl-required': 'external',
    resource: 'meulote-web',
    'public-client': true,
    'confidential-port': 0,
    clientId: 'meulote-web'
  })
} catch (error) {
  initNoKeycloakResponseApp()
}

if (keycloak != null) {
  keycloak.onTokenExpired = function () {
    keycloak.updateToken(15)
  }
  
  keycloak.onAuthRefreshSuccess = function () {
    setBearerToken(keycloak.token)
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + keycloak.token
  }
  
  keycloak.init({onLoad: 'login-required'})
    .then(auth => {
      if (auth) {
        const listRoles = process.env.VUE_APP_REQUIRED_ROLE.split(',')
        let hasRole = false
        listRoles.forEach(function (role) {
          if (keycloak.realmAccess.roles.indexOf(role) >= 0) {
            hasRole = true
          }
        })
        
        if (!keycloak.realmAccess || !hasRole) {
          initNotAuthorizedApp()
        } else {
          setBearerToken(keycloak.token)
          axios.defaults.headers.common['Authorization'] =
            'Bearer ' + keycloak.token
          initMainApp()
        }
      }
    })
    .catch(() => initNoKeycloakResponseApp())
}

function initMainApp() {
  Vue.prototype.$keycloak = keycloak
  Vue.prototype.$axios = axios
  
  if (
    process.env.VUE_APP_LOGROCKET_ENABLED &&
    process.env.VUE_APP_LOGROCKET_ENABLED === 1
  ) {
    LogRocket.init(
      process.env.VUE_APP_LOGROCKET_ID,
      {
        release: process.env.VUE_APP_VERSION
      }
    )
    LogRocket.identify(keycloak.tokenParsed.preferred_username)
  } else {
    // console.log('[LOGROCKET] not enabled!')
  }
  
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_ANALYTICS_ID,
    router,
    debug: {
      sendHitTask: process.env.VUE_APP_ANALYTICS_ENABLED === 1
    }
  })
  
  new Vue({
    i18n,
    router,
    store,
    el: '#app',
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

function initNotAuthorizedApp() {
  Vue.prototype.$keycloak = keycloak
  new Vue({
    vuetify,
    render: h => h(NotAuthorizedApp)
  }).$mount('#app')
}

function initNoKeycloakResponseApp() {
  new Vue({
    vuetify,
    render: h => h(NoKeykloakResponseApp)
  }).$mount('#app')
}